import React from 'react';
import styled from 'styled-components';
import BrandButton from 'UI/common/brandButtonV3';
import { appStore } from 'store';
import { Agreements } from '../agreements';
import SafeCheckout from 'modules/paywall/components/safeCheckout';
import { useT } from '@hooks';

const Container = styled.div`
	margin-top: 30px;
`;

const Text = styled.div`
	margin-bottom: 16px;
	color:  #7b798f;
	font-size: 12px;
	line-height: 14px;
	margin-bottom: 16px;

	& a {
		text-decoration: underline;
		color: ${({ theme }) => theme.colors.text14};
	}
`;

const AgreementsWrapper = styled.div`
	margin-bottom: 20px;
`;

const SafeCheckoutWrapper = styled.div`
	margin-top: 20px;
	padding-top: 20px;
`;

export function GetMyPlanBlock(props) {
	const { paymentStore } = appStore;
	const { T } = useT();
	const { withRenewalText = true, animateButton = false } = props;
	const { currencyType } = appStore.paymentStore.settings;

	function showPaymentModal() {
		const rootElement = document.querySelector('#root');
    if (rootElement) {
			rootElement.scrollTop = 0;
		}
		paymentStore.setPaymentModalVisible(true);
	}

	return (
		<Container>
			<Text>
				<span>
					{T('new_subscritions_agreement')}{' '}
					<a href='https://verv.com/terms-conditions/' target='_blank' rel='noreferrer'>
						{T('terms_conditions')}
					</a>{' '}
					{T('new_subscritions_and')}{' '}
					<a href='https://verv.com/privacy-policy-main/' target='_blank' rel='noreferrer'>
						{T('privacy_policy')}.
					</a>
				</span>
			</Text>
			<AgreementsWrapper>
				<Agreements currency={currencyType} withRenewalText={withRenewalText} />
			</AgreementsWrapper>
			<BrandButton
				data-test='open-payment-modal'
				onClick={showPaymentModal}
				animateButton={animateButton}
			>
				Try 7-day for FREE
			</BrandButton>
			<SafeCheckoutWrapper>
				<SafeCheckout />
			</SafeCheckoutWrapper>
		</Container>
	);
}